import { render } from "./ListeReclamation.vue?vue&type=template&id=9c901ec0&ts=true"
import script from "./ListeReclamation.vue?vue&type=script&lang=ts"
export * from "./ListeReclamation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__